module.exports = __webpack_public_path__ + "static/media/logo.cfb126a5.png";